import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Page from './views/Page.vue'
import NewsList from './views/NewsList.vue'
import NewsFull from './views/NewsFull.vue'
import Sedi from './views/Sedi.vue'
import PageSingle from './views/PageSingle.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/front',
      name: 'front',
      component: Home
    },
    {
      path: '/noi',
      name: 'noi',
      props: true,
      component: Page
    },
    {
      path: '/societa',
      name: 'societa',
      props: true,
      component: Page
    },
    {
      path: '/responsabilita-sociale',
      name: 'responsabilita-sociale',
      props: true,
      component: Page
    },
    {
      path: '/news',
      name: 'news',
      props: true,
      component: NewsList
    },
    {
      path: '/news/:slug',
      name: 'newsFull',
      props: true,
      component: NewsFull
    },
    {
      path: '/contatti',
      name: 'contatti',
      props: true,
      component: Sedi
    },
    {
      path: '/cookie-policy',
      name: 'cookie-policy',
      props: { default: true, nodetitle: 'Cookie policy' },
      component: PageSingle
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      props: { default: true, nodetitle: 'Privacy policy' },
      component: PageSingle
    },
    {
      path: '/company-data',
      name: 'company-data',
      props: { default: true, nodetitle: 'Dati societari' },
      component: PageSingle
    },
  ]
});
